import axiosInsAcademy from "../axios-ugems-academy";

export default {
  // Get all courses for Mitra Unenrollment
  getCourses(params) {
    return axiosInsAcademy.get('/tna/partner/unenrollment/courses', { params });
  },

  // Get course detail
  getCourseDetail(id) {
    return axiosInsAcademy.get(`/tna/partner/unenrollment/courses/${id}`);
  },

  // Get batches for cancellation
  getBatches(courseId, params) {
    return axiosInsAcademy.get(`/tna/partner/unenrollment/courses/${courseId}/batches`);
  },

  // Cancel participants for a batch (Submit Unenrollment)
  cancelParticipants(trainingEventId, data) {
    // Transform data from { cancelled: [{ enrollment_id, reason }] } 
    // to { enrollments: [{ partner_tna_enrollment_id, note }] }
    const payload = {
      enrollments: data.cancelled.map(item => ({
        partner_tna_enrollment_id: item.enrollment_id,
        note: item.reason || ''
      }))
    };
    
    return axiosInsAcademy.post(`/tna/partner/unenrollment/training-event/${trainingEventId}/submit`, payload);
  },

  // Get TNA summary statistics
  getSummary(params) {
    return axiosInsAcademy.get('/tna/partner/summary', { params });
  },

  // Download Excel template for bulk unenrollment
  downloadTemplate(courseId) {
    return axiosInsAcademy.get(`/tna/partner/unenrollment/courses/${courseId}/download-template`, {
      responseType: 'blob'
    });
  },

  // Bulk unenrollment via Excel upload
  bulkUnenrollment(courseId, formData) {
    return axiosInsAcademy.post(`/tna/partner/unenrollment/courses/${courseId}/upload-unenrollment`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }
};
